export default __webpack_public_path__ + "b3419f0c0076db5f18b5edcf66611a84.jpg";